export enum LanguageEnum {
  EN = 'en_GB',
  SE = 'sv_SE'
}
